import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";

import { api } from "../api";
import "./chat-ia-page.css";

const CHAT_URL = import.meta.env.VITE_CHAT_IA_URL || "https://cfo-ia.cogmo.com.br/";
const CHAT_ORIGIN = new URL(CHAT_URL).origin;

export function ChatIAPage({ user }) {
  const iframeRef = useRef(null);
  const [embedContext, setEmbedContext] = useState(null);
  const [iframeReady, setIframeReady] = useState(false);
  const payload = useMemo(
    () => embedContext && {
      nome: user.nome,
      email: user.email,
      is_admin: Boolean(user.administrador),
      database: embedContext.database,
      token: embedContext.token,
    },
    [embedContext, user],
  );

  useEffect(() => {
    let active = true;
    Promise.all([api.auth.config(), api.auth.chatEmbedToken()])
      .then(([config, token]) => {
        if (
          active &&
          typeof config?.database === "string" &&
          typeof token?.token === "string"
        ) {
          setEmbedContext({ database: config.database, token: token.token });
        }
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  useLayoutEffect(() => {
    function handleMessage(event) {
      const iframe = iframeRef.current;
      if (!iframe || event.data?.type !== "autus:ready") return;
      if (event.source !== iframe.contentWindow || event.origin !== CHAT_ORIGIN) return;
      setIframeReady(true);
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    if (!iframeReady || !payload) return;
    iframeRef.current?.contentWindow?.postMessage(payload, CHAT_ORIGIN);
  }, [iframeReady, payload]);

  return (
    <div className="chat-ia-screen">
      <iframe
        ref={iframeRef}
        className="chat-ia-frame"
        src={CHAT_URL}
        title="Chat de IA CFO Autus"
      />
    </div>
  );
}
